import { useMemo } from 'react'

import { matchFilterNumber, sortArrayBy } from '@domain-group/javascript-utils'

import { useWatchEntityUpdates } from '@domain-group/react-hooks'

import useSelector from '@hooks/useSelector'

import type { CreditNoteItemModel, CreditNoteItemRequestOptions } from '@models/types'

const watchEntityKeys = ['creditNote', 'creditNoteItems']

type CreditNoteItemFilters = {
  credit_note_id?: number,
}

type UseCreditNoteItemsOptions = {
  filters?: CreditNoteItemFilters,
  performHttpRequests?: boolean,
  requestOptions?: CreditNoteItemRequestOptions,
}

function useCreditNoteItems(options: UseCreditNoteItemsOptions) {
  const { filters = {} } = options
  const {
    credit_note_id: filterCreditNoteId,
  } = filters

  const {
    updatedEntities: {
      creditNote: creditNoteUpdatedAt,
      creditNoteItems: creditNoteItemsUpdatedAt,
    },
  } = useWatchEntityUpdates(watchEntityKeys)

  const { creditNoteItems } = useSelector(reduxState => reduxState.entities)

  const filteredCreditNoteItems = useMemo(() => {
    const filtered = Object.values(creditNoteItems).filter((creditNoteItem: CreditNoteItemModel) => {
      const { credit_note_id } = creditNoteItem

      const matchCreditNote = matchFilterNumber(credit_note_id, filterCreditNoteId)

      return matchCreditNote
    })

    return sortArrayBy(filtered, 'asc')
  }, [creditNoteUpdatedAt, creditNoteItemsUpdatedAt, JSON.stringify(filters)])

  const filteredCreditNoteItemsCount = filteredCreditNoteItems.length
  const hasFilteredCreditNoteItems = !!filteredCreditNoteItemsCount

  return {
    filteredCreditNoteItems,
    filteredCreditNoteItemsCount,
    hasFilteredCreditNoteItems,
  }
}

export default useCreditNoteItems
